import IncomeExpenseReportScreen from "../components/IncomeExpenseReport/IncomeExpenseReportScreen";

export default function IncomeExpenseReportPage() {
  return <IncomeExpenseReportScreen />;
}
